import { z } from "zod";

import { parseResponseData, privateAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import type { PastMedicationRequest } from "../models";
import {
  medicationRequestSchema,
  pastMedicationRequestSchema,
} from "../models";

export const getCurrentMedicationRequests = async () => {
  const response = await privateAPI.get("/patients/current-medication-request");

  return parseResponseData(response, z.array(medicationRequestSchema));
};

export const getPastMedicationRequests = async () => {
  const { data } = await privateAPI.get<
    ServiceResponse<PastMedicationRequest[]>
  >("/patients/past-medications");

  return z.array(pastMedicationRequestSchema).parse(data.data);
};
